export const SET_PIP_EVENTS = 'SET_PIP_EVENTS';
export const SET_PIP_SIZES = 'SET_PIP_SIZES';
export const SET_PIP_TILE_VIEW_LIST = 'SET_PIP_TILE_VIEW_LIST';
export const UPDATE_USER_IN_TILE_VIEW_LIST = 'UPDATE_USER_IN_TILE_VIEW_LIST';
export const SET_PIP_TILE_VIEW_CANVASES = 'SET_PIP_TILE_VIEW_CANVASES';
export const SET_PIP_STATUS = 'SET_PIP_STATUS';
export const SET_PIP_RAISED_HANDS = 'SET_PIP_RAISED_HANDS';
export const SET_PIP_REQUEST_ANIM_ID = 'SET_PIP_REQUEST_ANIM_ID';
export const SET_PIP_CANVAS_EL = 'SET_PIP_CANVAS_EL';
export const SET_PIP_STREAM_TO_MAIN_VIDEO_EL = 'SET_PIP_STREAM_TO_MAIN_VIDEO_EL';
export const SET_PIP_STREAM_TO_LOCAL_VIDEO_EL = 'SET_PIP_STREAM_TO_LOCAL_VIDEO_EL';
export const SET_PIP_VIRTUAL_VIDEO_EL = 'SET_PIP_VIRTUAL_VIDEO_EL';
export const SET_PIP_MAIN_VIDEO_EL = 'SET_PIP_MAIN_VIDEO_EL';
export const SET_PIP_LOCAL_VIDEO_EL = 'SET_PIP_LOCAL_VIDEO_EL';
